module.exports = __webpack_public_path__ + "static/media/EE.c0efdb96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/EE.svg
// module id = 2144
// module chunks = 7